import { Tag, Box, Grid, IconButton, Button as ButtonChakra ,
        //  GridItem,  FormLabel,ButtonGroup,Avatar,Badge,InputRightAddon,Checkbox,
         Image ,Text,         
         InputGroup,InputLeftAddon,Stack,
         Input, Select, Textarea, useDisclosure } from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { useEffect, useRef, useState } from "react";

import { FloatButton, Switch, Space  } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import React from "react";

import {FaTimes, FaCheck } from "react-icons/fa";

import { useMediaQuery } from "@chakra-ui/react"

import { useDispatch, useSelector } from "react-redux";
// import { getNotes, createNotes, updateNotes, deleteNotes } from "../redux/notes/note_actions";
import { getNotes, createNotes, updateNotes} from "../redux/notes/note_actions";

import { getDestinos} from "../redux/destinos/destino_actions";
import { getEstados} from "../redux/estados/estado_actions";

import DataTable from 'react-data-table-component';

import {Toaster } from 'react-hot-toast';
 
// import ModalNote from "../components/ModalNotes/ModalNote"

import { Table, Icon } from "semantic-ui-react";

import { SelectFiltros } from "../components/Notes/SelectFiltros";

import "./Notespage.scss";



import NoteCard from "../components/Notes/NoteCard/NoteCard";

import { Wrap, WrapItem } from '@chakra-ui/react'
import { Center } from '@chakra-ui/react'

import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional







import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
} from "@chakra-ui/react";

export default function Notespage()
{
    
    const dispatch = useDispatch()
    const {/*loading, */ error, data} = useSelector((state)=>state.noteReducer)
    const {/*loadingdestino, errordestino,*/ datadestino} = useSelector((state)=>state.destinoReducer)
    const {/*loadingestado, errorestado,*/ dataestado} = useSelector((state)=>state.estadoReducer)
    const [notes, setNotes] = useState([])
    
    const { isOpen, onOpen, onClose } = useDisclosure()
//    const { isOpen: isOpen2, onOpen: onOpen2, onClose: onClose2 } = useDisclosure()    
    const modalEdit = useDisclosure()

    const initialRef = useRef(null)
    const finalRef = useRef(null)
    const [title, setTitle] = useState("")
    const [documento, setDocumento] = useState("")
    const [telefono, setTelefono] = useState("")
    const [correoelectronico, setCorreoElectronico] = useState("")
    const [referencia, setReferencia] = useState("")
    const [estado, setEstado] = useState("")
    const [pagado, setPagado] = useState(0)
    const [destino, setDestino] = useState("")
    const [body, setBody] = useState("")
    const [notasinternas, setNotasInternas] = useState("");

    // const [destinos, setDestinos] = useState([])
    // const [estados, setEstados] = useState([])

    const [pending, setPending] = useState(true);

    const [filtroestados, setFiltroEstados] = useState([]);
    const [filtrodestinos, setFiltroDestinos] = useState([]);

    const [overlay, setOverlay] = useState()
    



    const [tempTitle, setTitle2] = useState(title)
    const [tempDocumento, setDocumento2] = useState(documento)
    const [tempTelefono, setTelefono2] = useState(telefono)
    const [tempCorreoElectronico, setCorreoElectronico2] = useState(correoelectronico)
    const [tempReferencia, setReferencia2] = useState(referencia)
    const [tempEstado, setEstado2] = useState(estado)
    const [tempDestino, setDestino2] = useState(destino)
    const [tempBody, setBody2] = useState(body)
    const [tempNotasInternas, setNotasInternas2] = useState(notasinternas)
    const [tempPagado,setPagado2] = useState(pagado);
    const [tempID,setId] = useState();  
    
    const [filtrosEdicion,setFiltrosEdicion] = useState('')
    const [verEtiquetas,setVerEtiquetas] = useState(true)
    
    useEffect(()=>{             
        dispatch(getNotes());               
        dispatch(getDestinos());        
        dispatch(getEstados());      
    },[])    

    useEffect(() => {     
      var filtros = {
        filtroestados: JSON.stringify(filtroestados),
        filtrodestinos: JSON.stringify(filtrodestinos),           
      };      
      
      setFiltrosEdicion(filtros);

      dispatch(getNotes(filtros));
      if (!isMobile) { setVerEtiquetas(false) }
    }, [filtroestados, filtrodestinos]);    

    useEffect(()=>{
        setNotes(data);
        console.log(" DATA Notas => ",data);
        setPending(false);

        if (!isMobile) { setVerEtiquetas(false) }
        
    }, [data,datadestino,dataestado])

    const createNote = ()=>{
        dispatch(createNotes({title, documento, telefono, correoelectronico, referencia, estado, destino, pagado, body, notasinternas}))
        onClose()
    }




    const updateNote = ()=>{
      dispatch(updateNotes(tempID, {title: tempTitle, 
                                 documento:tempDocumento, 
                                 telefono: tempTelefono, 
                                 correoelectronico: tempCorreoElectronico, 
                                 referencia: tempReferencia, 
                                 estado: tempEstado, destino: tempDestino, pagado: tempPagado, body: tempBody, notasinternas: tempNotasInternas},filtrosEdicion))
      modalEdit.onClose();
    }
        

    // console.log(" Error Notas => ",error)

    const columns = [
      {
        name: "Acciones",width:"100px",
        selector: (row) => {
          return (
            <Actions
              row={row}
              id={row.id}
              setId={setId}
              modalEdit={modalEdit}
              setTitle2={setTitle2}
              setDocumento2={setDocumento2}
              setTelefono2={setTelefono2}
              setCorreoElectronico2={setCorreoElectronico2}
              setReferencia2={setReferencia2}
              setEstado2={setEstado2}
              setDestino2={setDestino2}
              setBody2={setBody2}
              setNotasInternas2={setNotasInternas2}
              setPagado2={setPagado2}
            />
          );
        },
      },      
      {name: 'Destino', selector: row => row.destino,sortable: true,
      },      
      {name: 'Nombre', selector: row => row.title,sortable: true,width:"250px",
        cell: (row) => creaHint(row, row.estado),
      },
      {name: 'Nº Documento', selector: row => row.documento,sortable: true,width:"100px"},
      {name: 'Teléfono', selector: row => row.telefono,sortable: true,width:"100px"},
      {name: 'Correo Elec.', selector: row => row.correoelectronico,sortable: true,},
      {name: 'Creado', selector: row => row.createdAt,sortable: true,
          cell : (row) => campoFecha(row.createdAt)
      },      
      {name: 'Modificado', selector: row => row.updatedAt,sortable: true,
        cell : (row) => campoFecha(row.updatedAt)
      },            
      //{name: 'Pagado', selector: row => row.pagado,sortable: true,},
      {
        name: "Pagado",width:"75px",
        selector: (row) => {
          return (
            <ViewChecks
              valor={row.pagado}
            />
          );
        },
      },
      {name: 'Estado', /*selector: row => row.estado,*/sortable: true,center:true,width:"120px",
        cell: (row) => tagColor(row, row.estado),
      },                  
    ];

    //fechasubida: moment(body2.result[i].creation).format("DD/MM/YYYY h:mm"),

    const paginationComponentOptions = {
      rowsPerPageText: 'Filas por página',
      rangeSeparatorText: 'de',
      selectAllRowsItem: true,
      selectAllRowsItemText: 'Todos',
    };

    // const clickhandler = name => console.log("delete", name);
    

    const [isMobile] = useMediaQuery("(max-width: 768px)") 

    const OverlayTwo = () => (
      <ModalOverlay
        bg='none'
        backdropFilter='auto'
        backdropInvert='80%'
        backdropBlur='2px'
      />
    )   

    const tableData = {
      columns,
      data
    };
    

    const onChangeSwitch = (checked) => {
      // console.log(`switch to ${checked}`);
      setVerEtiquetas(checked)
    };
   

    
    return (      
      
      <>
         
 
    <FloatButton 
        icon={<AddIcon fontSize={20} />}
        type="primary"
        onClick={() => {
                setOverlay(<OverlayTwo />)
                setTitle('');
                setDocumento('');
                setTelefono('');
                setCorreoElectronico('');
                setReferencia('');
                setEstado('Pendiente');
                setPagado('');
                setDestino('');
                setBody('');
                setNotasInternas('');
                onOpen()
            }} />;    
    <Box mt={20} padding={18} >   
   
      
    
      <Wrap>
        <WrapItem>
          <Center w='180px' h='40px' >
            {/* <IconButton
              isRound={true}
              variant='solid'
              colorScheme='blue'
              aria-label='Done'
              fontSize='20px'
              icon={<AddIcon fontSize={30} />}
              onClick={() => {
                setOverlay(<OverlayTwo />)
                setTitle('');
                setDocumento('');
                setTelefono('');
                setCorreoElectronico('');
                setReferencia('');
                setEstado('Pendiente');
                setPagado('');
                setDestino('');
                setBody('');
                onOpen()
            }}
            >Insertar</IconButton> */}
            
          
              
          </Center>
        </WrapItem>
      </Wrap>


      
      <SelectFiltros
                  destinos={datadestino ? datadestino : []}
                  estados={dataestado ? dataestado : []}
                  setFiltroDestinos={setFiltroDestinos}
                  setFiltroEstados={setFiltroEstados}            
              />

      

      
      {isMobile ? 
          <>
          <Space direction="vertical">
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              defaultChecked
              onChange={onChangeSwitch}
            >              
            </Switch>
            <Text> Ver Etiquetas</Text >
            
          </Space>
          </>
        : ''}
      {verEtiquetas && isMobile ? 
          <Grid gap={10} w={"100%"} margin={"auto"} gridTemplateColumns="repeat(1, 1fr)">
               {notes?.map((el)=><NoteCard {...el}/>)}
               {/* {notes?.map((el)=>{<Text>{el.title}</Text>})}                                */}
          </Grid>  
           : 
           
          <DataTableExtensions {...tableData}
              print={false}
              export={false}>
              <DataTable
                dense  
                striped
                progressPending={pending}
                title="Notas"
                columns={columns}
                data={data}
                pagination
                highlightOnHover
                paginationComponentOptions={paginationComponentOptions}
                paginationRowsPerPageOptions={[100,200,300,400,500]}
                paginationPerPage={100}
                // onContextMenu={handleContextMenu}
              />
          </DataTableExtensions>
       } 
           
      <>        
        {/* Modal Insertar */}
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          closeOnOverlayClick={false}
          isOpen={isOpen}
          onClose={onClose}
          // size="xl"

          size={[
            "xl", // base
            "100%", // 480px upwards
            "100%", // 768px upwards
            "100%", // 992px upwards
          ]}
        >
          {overlay}
          <ModalOverlay />
          <ModalContent  maxW={isMobile ? "100%" : "40%"}>

          {/* {isMobile ? "This is a mobile device" : "This is a desktop device"} */}


          {/* <ModalContent width={{md: "500px", base: "100px"}} height={{md: "100px", base: "100px"}}> */}
            <ModalHeader>Crear nueva nota</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>  
                <Stack spacing={4}>
                    <InputGroup>
                        <InputLeftAddon width={150}>Destino</InputLeftAddon>
                        <Select  ref={initialRef} placeholder='Selecciona Opción' onChange={(e)=>setDestino(e.target.value)}>
                                    { datadestino?.map(c => (<option key={c.descripcion} value={c.descripcion}>{c.descripcion}</option>))}
                        </Select>
                    </InputGroup>  

                    <InputGroup>
                        <InputLeftAddon width={150}>Nombre</InputLeftAddon>
                        <Input value={title}m placeholder="Introduce el nombre" onChange={(e)=>setTitle(e.target.value)}></Input>
                    </InputGroup>                      

                    <InputGroup>
                        <InputLeftAddon width={150}>Nº Documento</InputLeftAddon>
                        <Input value={documento} name="documento" placeholder="Introduce el nº documento" onChange={(e)=>setDocumento(e.target.value)}></Input>
                    </InputGroup>                                          

                    <InputGroup>
                        <InputLeftAddon width={150}>Teléfono</InputLeftAddon>
                        <Input value={telefono}m placeholder="Introduce el teléfono" onChange={(e)=>setTelefono(e.target.value)}></Input>
                    </InputGroup>                        

                    <InputGroup>
                        <InputLeftAddon width={150}>Correo Electrónico</InputLeftAddon>
                        <Input value={correoelectronico}m placeholder="Introduce el correo electrónico" onChange={(e)=>setCorreoElectronico(e.target.value)}></Input>
                    </InputGroup>                     

                    <InputGroup>
                        <InputLeftAddon width={150}>Referencia</InputLeftAddon>
                        <Input value={referencia}m placeholder="Introduce la referencia" onChange={(e)=>setReferencia(e.target.value)}></Input>
                    </InputGroup>                                         

                    <InputGroup>
                        <InputLeftAddon width={150}>Estado</InputLeftAddon>
                        <Select placeholder='Selecciona Opción' onChange={(e)=>setEstado(e.target.value)} defaultValue="Pendiente">
                            {  dataestado?.map(c => <option key={c.descripcion} value={c.descripcion}>{c.descripcion}</option>)}                                                  
                        </Select>
                    </InputGroup>                                                             

                    <InputGroup>
                            <InputLeftAddon width={150}>Pagado</InputLeftAddon>
                            {/* <Checkbox isChecked={pagado} onChange={(e)=>setPagado(e.target.checked)}>Pagado</Checkbox>                             */}
                            <BotonPagado valor={pagado} setPagado2={setPagado} />                            
                    </InputGroup>                    

                    <InputGroup>
                            <InputLeftAddon width={150}>Notas</InputLeftAddon>
                            <Textarea value={body} placeholder='Introduce notas' onChange={(e)=>setBody(e.target.value)}></Textarea>
                    </InputGroup>                                        
                    <InputGroup>
                            <InputLeftAddon width={150}>Notas Internas</InputLeftAddon>
                            <Textarea value={notasinternas} placeholder='Introduce notas' onChange={(e)=>setNotasInternas(e.target.value)}></Textarea>
                    </InputGroup>                                                            


                </Stack>
            </ModalBody>

            <ModalFooter>            
              <ButtonChakra colorScheme="blue" mr={3} onClick={createNote}>
                Crear
              </ButtonChakra>
              <ButtonChakra onClick={onClose}>Cancelar</ButtonChakra>
            </ModalFooter>
          </ModalContent>
        </Modal>
        
        </>

        {/* Modal Editor */}
        <>               
        <Modal
            initialFocusRef={initialRef}
            finalFocusRef={finalRef}
            closeOnOverlayClick={false}
            isOpen={modalEdit.isOpen} onClose={modalEdit.onClose}
        >
            <ModalOverlay />
            <ModalContent  maxW={isMobile ? "100%" : "40%"}>
              <ModalHeader>Editar Nota</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                  <Stack spacing={4}>
                      <InputGroup>
                          <InputLeftAddon width={150}>ID</InputLeftAddon>
                          <Input isDisabled value={tempID} onChange={(e)=>setId(e.target.value)}></Input>
                      </InputGroup>

                      <InputGroup>
                          <InputLeftAddon width={150}>Destino</InputLeftAddon>
                          <Select placeholder='Selecciona Opción' onChange={(e)=>setDestino2(e.target.value)}
                                defaultValue={tempDestino}>
                                    { datadestino?.map(c => (<option key={c.descripcion} value={c.descripcion}>{c.descripcion}</option>))}
                          </Select>                          
                      </InputGroup>                                                                              

                      <InputGroup>
                          <InputLeftAddon width={150}>Nombre</InputLeftAddon>
                          <Input value={tempTitle} name="nombre" placeholder="Introduce el nombre" onChange={(e)=>setTitle2(e.target.value)}></Input>
                      </InputGroup>

                      <InputGroup>
                          <InputLeftAddon width={150}>Documento</InputLeftAddon>
                          <Input value={tempDocumento} name="documento" placeholder="Introduce el nº documento" onChange={(e)=>setDocumento2(e.target.value)}></Input>                            
                      </InputGroup>

                      <InputGroup>
                          <InputLeftAddon width={150}>Teléfono</InputLeftAddon>
                          <Input value={tempTelefono}m placeholder="Introduce el teléfono" onChange={(e)=>setTelefono2(e.target.value)}></Input>                            
                          <BotonWhatsapp telefono={tempTelefono} />
                      </InputGroup>                          

                      <InputGroup>
                          <InputLeftAddon width={150}>Correo Electrónico</InputLeftAddon>
                          <Input value={tempCorreoElectronico}m placeholder="Introduce el correo electrónico" onChange={(e)=>setCorreoElectronico2(e.target.value)}></Input>                            
                      </InputGroup>

                      <InputGroup>
                          <InputLeftAddon width={150}>Referencia</InputLeftAddon>
                          <Input value={tempReferencia}m placeholder="Introduce la referencia" onChange={(e)=>setReferencia2(e.target.value)}></Input>                            
                      </InputGroup>

                      <InputGroup>
                          <InputLeftAddon width={150}>Estado</InputLeftAddon>
                          <Select placeholder='Selecciona Opción' onChange={(e)=>setEstado2(e.target.value)}
                                defaultValue={tempEstado} >
                                    { dataestado?.map(c => (<option key={c.descripcion} value={c.descripcion}>{c.descripcion}</option>))}
                          </Select>
                      </InputGroup>

                      <InputGroup>
                          <InputLeftAddon width={150}>Pagado</InputLeftAddon>
                            {/* <Checkbox isChecked={tempPagado} onChange={(e)=>setPagado2(e.target.checked)}>Pagado</Checkbox>                             */}
                          <BotonPagado valor={tempPagado} setPagado2={setPagado2} />                            
                      </InputGroup>

                      <InputGroup>
                          <InputLeftAddon width={150}>Notas</InputLeftAddon>
                          <Textarea value={tempBody} placeholder='Introduce notas' onChange={(e)=>setBody2(e.target.value)}></Textarea>
                      </InputGroup>                                                                                                        
                      <InputGroup>
                          <InputLeftAddon width={150}>Notas Internas</InputLeftAddon>
                          <Textarea value={tempNotasInternas} placeholder='Introduce notas' onChange={(e)=>setNotasInternas2(e.target.value)}></Textarea>
                      </InputGroup>                                                                                                                              
                  </Stack>                      
              </ModalBody>

              <ModalFooter>
                  <ButtonChakra olorScheme="blue" mr={3} onClick={updateNote}> 
                      Guardar
                  </ButtonChakra> 
                  <ButtonChakra onClick={modalEdit.onClose}>Cerrar</ButtonChakra>
              </ModalFooter>
          </ModalContent>
      </Modal>                  
      </>

     
      

      <Toaster/>

    </Box>
    
    </>
    )
}

function campoFecha(data){
    var moment = require('moment');
    return moment(data).format("DD/MM/YYYY HH:mm");
}
function tagColor(row, data) {
  
  if (!data) {
    return "";
  } else {
    var color = "";
    var colortexto = "";
    // var tag = "";


    colortexto = "black";


    if (row.estado.toUpperCase() === "finalizado".toUpperCase()) {
      color = "green";
      // tag = data;
    } else if (row.estado.toUpperCase() === "pendiente".toUpperCase()) {
      color = "red";
      // tag = data;
    } else if (row.estado.toUpperCase() === "avisado".toUpperCase()) {
      color = "blue";
      colortexto = "white";
      // tag = data;
    } else if (row.estado.toUpperCase() === "cancelado cliente".toUpperCase()) {
      color = "grey";
      // tag = data;
    } else if (row.estado.toUpperCase() === "ALBARÁN".toUpperCase()) {
      color = "blue";
      // tag = data;
    } else {
      color = "grey";
      // tag = data;
    }

    var valorcampo = data;

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          alignContent: "center",
          cursor: "pointer",
          textAlign: "center",
        }}
        data-tag="allowRowEvents"        
      >
          <Tag color={colortexto} bgColor={color} > {valorcampo}</Tag>


      </div>
    );
  }
}

function ViewChecks(props) {
  const { valor } = props;

  return (
    <Table.Cell className="status">
      {valor ? <Icon name="check" /> : <Icon name="close" />}      
    </Table.Cell>
  );
}

function BotonPagado (props) {
  const { valor , setPagado2} = props;

  return (
      
    <IconButton isRound={true} variant='solid' 
      // colorScheme='teal' 
      //onclick={(e)=>setPagado2(!valor)}
      onClick={() => { setPagado2(!valor) }}
      colorScheme={ valor ? 'teal' : 'red'}
      aria-label='Done' fontSize='20px' 
      icon={ valor ? <FaCheck /> : <FaTimes/>} />                                                                           
      
  );
}

function BotonWhatsapp (props) {
  const { telefono} = props;

  var link = "https://wa.me/34"+telefono;
  //console.log(" link => ",link);
  
  return (
    <>
    <a href={link} target="_blank">

    <Image src='/whatsapp.png' width={50} height={30} alt={link}
      // onclick={() => { console.log(" Telefono : ",link);}}    
      // onClick={() => { console.log(" Telefono : ",telefono);}}
        
          
        // }}
    />           
    </a>
    </>
  );
}


function creaHint(row, data) {
  
    // var valorcampo = data;
    // var colortexto = "black";
    // var color = "green";
    var datos = row.body;
    
    // if (row.notasinternas.length  > 5){
      if (row.notasinternas != null && row.notasinternas.length > 5) {
      datos = datos + ' \n\r*************************\n\r ' +
                row.notasinternas;
    }

    

    return (
        <Tippy content={datos}>
          <Text> {row.title}</Text >
        </Tippy>
    );
  }


function Actions(props) {
  const { row, modalEdit,
        id, 
        setId,
        setTitle2,
        setDocumento2,
        setTelefono2,
        setCorreoElectronico2,
        setReferencia2,
        setEstado2,
        setDestino2,
        setBody2,
        setNotasInternas2,
        setPagado2, } = props;

  return (
    <Table.Cell textAlign="right">
        <Icon name="pencil" onClick={() => {
                setId(id);
                setTitle2(row.title);
                setDocumento2(row.documento);
                setTelefono2(row.telefono);
                setCorreoElectronico2(row.correoelectronico);
                setReferencia2(row.referencia);
                setEstado2(row.estado);
                setDestino2(row.destino);
                setBody2(row.body);
                setNotasInternas2(row.notasinternas);
                setPagado2(row.pagado);
                modalEdit.onOpen();
          }}/> 
      
    </Table.Cell>
  );
}

